var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mt-2" },
    [
      _c("h4", [_vm._v("Other user's responses")]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.veracityResponses.length > 0
          ? _c(
              "div",
              [
                _c("p", [
                  _vm._v(
                    "See how other users rated the veracity of this rumour:"
                  )
                ]),
                _vm._v(" "),
                _vm._l(_vm.veracityResponses, function(vResponse) {
                  return _c(
                    "div",
                    { staticClass: "media mb-3 pr-3 pt-3 border rounded" },
                    [
                      _c("img", {
                        staticClass: "m-3",
                        attrs: { src: "/static/images/user.png", width: "30" }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "media-body" }, [
                        _c("div", { staticClass: "mb-2" }, [
                          _c("strong", [_vm._v(_vm._s(vResponse.username))]),
                          _vm._v(" - " + _vm._s(vResponse.date))
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [_vm._v("Provided veracity rating:")])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-4 text-left" }, [
                            _vm._v("False")
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-4 text-center" }, [
                            _vm._v("Unverified")
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-4 text-right" }, [
                            _vm._v("True")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          staticClass: "slider mb-3",
                          attrs: {
                            type: "range",
                            min: "-1",
                            max: "1",
                            step: "0.01",
                            "data-toggle": "tooltip",
                            "data-html": "true",
                            "data-placement": "bottom",
                            disabled: ""
                          },
                          domProps: { value: vResponse.veracity }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "mb-2" }, [
                          _c("strong", [_vm._v("Evidence for the rating:")]),
                          _vm._v(" "),
                          _c("p", [_vm._v(_vm._s(vResponse.evidence))])
                        ])
                      ])
                    ]
                  )
                })
              ],
              2
            )
          : _c("div", [
              _vm._v("\n            No user responses to this tweet.\n        ")
            ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }